<template>
  <div class="success">
    <section>
      <z-image width="98" px2rem src="n_v2f3be5806d01f4b7ea9c03d331b502d29.png" />
      <div class="title">{{ title }}</div>
      <div class="content">{{ content }}</div>
    </section>

    <z-button-group>
      <z-button
        type="primary"
        loading-text="提交..."
        btn-class="bottombtn"
        :disabled="disabled"
        :loading="isLoading"
        @click="toDetial()"
        >查看赔付进度</z-button
      >
    </z-button-group>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Button, ButtonGroup, Image } from '@zz-common/zz-ui'
// import { lego } from '@zz-common/lego'
import { queryParams } from '../../../../lib/utils'

const query = queryParams()

export default {
  name: 'SuccessComp',
  data() {
    return {
      orderId: query.orderId || this.$route.query.orderId, //1 平台规则 2 安全知识,
      isLoading: false,
      title: '赔付信息提交成功',
      disabled: false
    }
  },
  components: {
    zButtonGroup: ButtonGroup,
    zButton: Button,
    zImage: Image
  },
  methods: {
    toDetial(_value) {
      const targetUrl = `https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDetial&orderId=${this.orderId}`
      native.skipToUrl({
        targetUrl,
        needClose: '1'
      })
    }
  },
  computed: {
    content() {
      return Date.now() > new Date(2022, 2, 11).valueOf()
        ? '赔付信息等待后台审核中，如关注后续进程，可到【我的】-安全中心-赔付保障-我的记录里进行查看。'
        : '请耐心等待赔付审核，审核成功后可得到赔付。审核结果可到【我的】-安全中心-赔付保障-我的记录里进行查看。温馨提示：春节假期期间（01.26-02.07）提交的赔付申请将于02.08-02.10期间审核完毕。感谢您的理解，祝您春节愉快！'
    }
  },
  mounted() {
    native.setTitle({
      title: '放心转--官方欺诈赔付'
    })
    const obj = {
      label: '赔付说明',
      url: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDescription',
      newPageTitle: '赔付说明',
      needLogin: 0,
      color: '#111111'
    }
    native.wrap('setRightBtn')(obj)
  },
  destroyed() {},
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {})
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
